export default __webpack_public_path__ + "static/media/copas.9bdb2dbd.jpeg";